import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  Button,
  DialogActions
} from "@mui/material";

type Props = {
  open: boolean;
  onClose: () => void;
};

export default function ScanLicenseDialog({
  open,
  onClose,
}: Props) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle>
        Scanner une licence
      </DialogTitle>

      <DialogContent>
        <Typography gutterBottom>
          Initialisation de la caméra...
        </Typography>

        <Box
          sx={{
            height: 300,
            bgcolor: "black",
            borderRadius: 2,
          }}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>
          Fermer
        </Button>
      </DialogActions>
    </Dialog>
  );
}